import { Tag } from 'aui';
import clsx from 'clsx';

export type CustomTagProps = {
  className?: string;
  children?: React.ReactNode;
};

export function CustomTag(props: CustomTagProps) {
  const { className, children } = props;

  return (
    <Tag
      className={clsx(
        'animate-none rounded-lg border border-solid border-tag-border px-1.5 font-400 leading-5 transition-none',
        className,
      )}
    >
      {children}
    </Tag>
  );
}
